import { ApplicableToEnum, IncludeWithEnum, TransportationModeEnum } from "@/graphql/codegen/graphql"

export const TRANSPORTATION_MODE_ALL_LABEL = "All"
export const APPLICABLE_TO_ALL_LABEL = "All"

export const includeWithLabelMap = new Map<IncludeWithEnum, string>([
  [IncludeWithEnum.Billoflading, "Bill of Lading"],
  [IncludeWithEnum.Packingslip, "Packing Slip"],
  [IncludeWithEnum.Picklist, "Picklist"],
  [IncludeWithEnum.Po, "Purchase Order"],
  [IncludeWithEnum.Proformainvoice, "Proforma Invoice"],
  [IncludeWithEnum.Putaway, "Putaway"],
  [IncludeWithEnum.ShippingLabel, "Shipping Label"],
])

export const transportationModeLabelMap = new Map<TransportationModeEnum, string>([
  [TransportationModeEnum.Air, "Air"],
  [TransportationModeEnum.Ground, "Ground"],
  [TransportationModeEnum.Sea, "Sea"],
])

export const applicableToLabelMap = new Map<ApplicableToEnum, string>([
  [ApplicableToEnum.Domestic, "Domestic"],
  [ApplicableToEnum.Export, "Export"],
  [ApplicableToEnum.Import, "Import"],
])
